function getToastHeight(toastIndex: number): number {
    const toast = document.querySelector(
        `.toast-item[data-id="${toastIndex}"]`
    ) as HTMLDivElement | null;

    if (toast) {
        return toast?.offsetHeight ?? 0;
    }

    return 0;
}

function getCollapsedToastStyle(currentToastIndex: number, nbToasts: number) {
    const lastItemIndex = nbToasts - 1;
    const heightFirstToast = getToastHeight(lastItemIndex);

    if (heightFirstToast > 0) {
        const position = nbToasts - currentToastIndex - 1;
        return {
            transform: `translate3d(0, calc(-${heightFirstToast}px + -10px + 100% + -15px * ${position}), 0) scale(${
                1 - position * 0.05
            })`
        };
    }

    return {};
}

function getExpandedToastStyle(currentToastIndex: number, nbToasts: number) {
    let totalHeight = 0;
    for (let i = currentToastIndex; i < nbToasts; i++) {
        const toastIndex = i + 1;
        const heightToast = getToastHeight(toastIndex);
        totalHeight += heightToast;
        if (toastIndex !== nbToasts) {
            totalHeight += 10;
        }
    }

    if (totalHeight > 0) {
        return {
            transform: `translate3d(0, -${totalHeight}px, 0) scale(1)`
        };
    }

    return {};
}

export { getExpandedToastStyle, getCollapsedToastStyle };
